function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 17.5C0.9 17.5 0.8 17.5 0.8 17.4C0.6 17.3 0.5 17.1 0.5 17V2.3C0.5 2.1 0.6 2 0.7 1.9C4.9 -1.1 9.1 1.5 10.3 2.3C11.5 1.4 15.7 -1.2 19.9 1.9C20 2 20.1 2.1 20.1 2.3V17C20.1 17.2 20 17.4 19.8 17.4C19.6 17.5 19.4 17.5 19.3 17.4C15 14.3 10.8 17.2 10.5 17.4C10.3 17.5 10.1 17.5 9.9 17.4C9.7 17.2 5.4 14.3 1.1 17.4C1.2 17.5 1.1 17.5 1 17.5ZM10.8 3.2V16.1C12.3 15.3 15.7 14.1 19.1 16.1V2.6C15.4 0.0999997 11.7 2.6 10.8 3.2ZM5.5 15C7.4 15 9 15.6 9.9 16.1V3.2C9 2.6 5.3 0.0999997 1.5 2.6V16.1C2.9 15.3 4.2 15 5.5 15Z"
});

var SvgMajorIcon = function SvgMajorIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMajorIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/major-icon.d1de41a7.svg";
export { ForwardRef as ReactComponent };